// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders color options.
 */
M.View.ProductDetails.ColorPicker = Backbone.View.extend({
  className: 'colorPicker',

  template: M.Template.ProductDetail.ColorPicker,

  events: {
    'click .swatch': 'colorSwatchClick'
  },

  initialize: function() {
    if (!this.collection) {
      M.required(this.options.colorJson);
      this.collection = new M.Collection.ProductDetails.Colors(
        this.options.colorJson);
    }
  },

  render: function() {
    this.$el = $(this.el);
    this.$el.empty();

    var templateVariables = {
      colors: this.collection.models
    };

     var templateVariables = {
      colors: this.collection.models
    };
    this.$el.html(this.template(templateVariables));

    // Auto-select the first color choice
    var firstSwatch = this.$el.find('.swatch:first-child');
    firstSwatch.click();

    return this;
  },

  /**
   * Deselect any selected options.
   */
  deSelect: function() {
    this.$el.find('.swatch').removeClass('active');
    this.collection.select(null);
  },

  colorSwatchClick: function(e) {
    var previousColor = this.collection.getSelected();
    this.$el.find('.swatch').removeClass('selected');
    var clickedSwatch = $(e.currentTarget);
    clickedSwatch.addClass('selected');
    var selectedModel = this.collection.get(clickedSwatch.data('id'));
    this.collection.select(selectedModel);
    this.trigger('color_changed', previousColor);
  }
});
